import { combineReducers } from "redux";
import {
  fetching,
  submitting,
  items,
  togglable,
  selectable,
} from "./resource";

export default combineReducers({
  selectedItem: selectable("types"),
  isFetching: fetching("types"),
  isSubmitting: submitting("types"),
  items: items("types"),
  showAddModal: togglable("addModal"),
});
